import './wolfewine/style';
import FormStructure from './wolfewine/form_structure';

export default FormStructure;